'use strict';

angular.module('magview')
  .controller('PrefsCtrl', [
    '$scope', 'PrefsViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel();
    }
  ]);
